import React from "react";
import { useTranslation } from "react-i18next";
import AppModalShell, { AppModalButton } from "../common/AppModalShell";

export default function EventGenderConfirmationModal({
  open,
  onClose,
  onSelect,
  event = null,
  loading = false,
  error = "",
}) {
  const { t, i18n } = useTranslation("events");
  const formatTicketPrice = (rawValue) => {
    const amount = Number(rawValue);
    if (!Number.isFinite(amount)) {
      return t("join_section.gender_confirmation.price_applies");
    }
    if (amount <= 0) {
      return t("join_section.gender_confirmation.free_entry");
    }
    return new Intl.NumberFormat(i18n.resolvedLanguage || i18n.language || "en", {
      style: "currency",
      currency: "EUR",
      minimumFractionDigits: amount % 1 === 0 ? 0 : 2,
      maximumFractionDigits: 2,
    }).format(amount);
  };
  const maleLabel = t("join_section.gender_confirmation.male", {
    price: formatTicketPrice(event?.male_ticket_price),
  });
  const femaleLabel = t("join_section.gender_confirmation.female", {
    price: formatTicketPrice(event?.female_ticket_price),
  });

  return (
    <AppModalShell
      open={Boolean(open)}
      title={t("join_section.gender_confirmation.title")}
      description={t("join_section.gender_confirmation.description")}
      onClose={loading ? undefined : onClose}
      closeAriaLabel={t("join_section.gender_confirmation.close_aria")}
      maxWidthClassName="max-w-md"
      footer={
        <div className="grid grid-cols-1 gap-3">
          <AppModalButton
            onClick={() => onSelect?.("male")}
            disabled={loading}
            loading={loading}
            className="text-[#2563EB]"
          >
            {maleLabel}
          </AppModalButton>
          <AppModalButton
            variant="secondary"
            onClick={() => onSelect?.("female")}
            disabled={loading}
          >
            {femaleLabel}
          </AppModalButton>
          <AppModalButton
            variant="secondary"
            onClick={onClose}
            disabled={loading}
          >
            {t("join_section.gender_confirmation.cancel")}
          </AppModalButton>
        </div>
      }
    >
      <div className="space-y-3 text-center text-sm leading-6 text-white/76">
        <p>{t("join_section.gender_confirmation.pricing_note")}</p>
        {error ? <p className="text-red-200">{error}</p> : null}
      </div>
    </AppModalShell>
  );
}
